import { doc, updateDoc } from "firebase/firestore";
import React, { useEffect } from "react";
import { updatePlayerAttribute } from "../firebase/fireFuncs";
import db from "../firebase/fireInit";
import { updatePlayerArrays } from "../firebase/playerFuncs";
import useModal from "../hooks/useModal";
import { getTimeDiff } from "../misc/helperfuncs";
import MoodModal from "../modals/moodModal";
import MainStore from "../stores/MainStore";

const ActiveMood = ({ updateActiveGoalMoods, setActiveMood }) => {
  const { player } = MainStore();

  const modal = useModal({
    modalContent: <MoodModal changeMood={setActiveMood} />,
    password: "lastMood",
  });

  const moods = {
    confused: "/icons/icon_confused.png",
    angry: "icons/icon_angry.png",
    productive: "icons/icon_productive.png",
    tired: "icons/icon_tired.png",
    happy: "icons/icon_happy.png",
    exhausted: "icons/icon_exhausted.png",
    sad: "icons/icon_sad.png",
    unknown: "icons/icon_question.png",
  };
  return (
    <div
      className="divColumn"
      style={{ backgroundColor: "#2f2f2f", width: "100%", padding: "5px" }}
    >
      <div className="textBlack" style={{ color: "white" }}>
        ActiveMood
      </div>
      <img
        className="icon40"
        onClick={() => {
          modal.open("lastMood");
        }}
        src={moods[player?.active.mood?.type] ?? "icons/icon_question.png"}
      />
      {modal.element}
    </div>
  );
};

export default ActiveMood;
